import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { API_URL, APP_ROLES, DEFAULT_PER_PAGE, RS_TAGLINE, SYSTEM_TOKEN } from "../../utilities/constants";
import { decodeRolesFromToken } from "../../utilities/helpers";
import PageTitle from "../../components/common/PageTitle";
import { getDefaultURLForRole } from "../../services/roles";
import ButtonTextOnly from "../../components/ui/ButtonTextOnly";
import ButtonTextIcon from "../../components/ui/ButtonTextIcon";
import LoaderIcon from "../../components/common/LoaderIcon";
import { useUI } from "../../context/ui";
import { FaEye, FaRegEyeSlash } from 'react-icons/fa';


const Login = () => {
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const { addToastMessage } = useUI();
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};


	const FormValidation = Yup.object().shape({
		username: Yup.string()
		.required('Email is required!')
		.test('no-spaces', 'Email should not contain spaces.', value => !/\s/.test(value || ''))
		.email('Please enter a valid email.'),
		password: Yup.string().required("Password is required!"),
	});

	// ======== FOR DEV ONLY ====== //
	const SUPERADMIN = {
		username: "superadmin@gasolina.com",
		password: "Welcome01#",
	};
	const FINANCE = {
		username: "tom@gmail.com",
		password: "Welcome01#",
	};

	const initial =
		process.env.NODE_ENV === "development"
			? SUPERADMIN
			: {
				username: "",
				password: "",
			};

	const checkIfNextURLExists = () => {
		const params = new URLSearchParams(location.search);
		const queryObj = {};
		params.forEach((value, key) => {
			queryObj[key] = value;
		});
		if (queryObj.next) {
			return queryObj.next;
		} else {
			return false;
		}
	};


function getRoleDetails(roleId) {
    return APP_ROLES.find(role => role.roleId === roleId);
}

	const handleLogin = async (username, password) => {
		setLoading(true);
		setStatus("");
		try {
			const resp = await fetch(API_URL + "/api/1.0.0/login", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-JWT-Assertion": SYSTEM_TOKEN,
				},
				body: JSON.stringify({
					username: username,
					password: password,
				}),
			});
			if (resp.ok) {
				const response = await resp.json();
				if (response.accessToken) {
					if (
						localStorage.setItem("token", response.accessToken) ===
						undefined
					) {
						const nextURL = checkIfNextURLExists();
						if (response.flow?.length > 0) {
							if (
								localStorage.setItem(
									"flow",
									JSON.stringify(response.flow)
								) === undefined
							) {
								if (nextURL) {
									navigate(
										response.flow[0] + "?next=" + nextURL
									);
								} else {
									navigate(response.flow[0]);
								}
							} else {
								setStatus("Could not store flow");
							}
						} else {
							const roles = decodeRolesFromToken();
							if (nextURL) {
								navigate(nextURL);
							} else {
								if(roles.includes(10)){
									navigate("/site-config");
								}else if(roles.includes(7)){
									navigate(`/transactions?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`);
								}else if(roles.includes(4)){
									navigate("/profile"); //roles.includes(5) ||
								}else{
									navigate("/dashboard");
								}
								// if (roles.includes(1)) {
								// 	console.log("admin login");
								// 	navigate("/dashboard");
								// } else if (roles.includes(3)) {
								// 	console.log("finance login");
								// 	navigate("/transactions");
								// } else {
								// 	console.log("petrol Attendant login");
								// 	navigate("/profile");
								// }
							}
						}
						setStatus("Welcome to Gasolina.com");
					} else {
						setStatus("Could not store token");
					}
				} 
				// if (response.accessToken) {
				// 	localStorage.setItem("token", response.accessToken);
			
				// 	const nextURL = checkIfNextURLExists();
				// 	const roleId = decodeRolesFromToken()[0]; // Assuming this function returns an array of role IDs
				// 	const roleDetails = getRoleDetails(roleId);
			
				// 	if (response.flow?.length > 0) {
				// 		localStorage.setItem("flow", JSON.stringify(response.flow));
			
				// 		if (nextURL) {
				// 			navigate(`${response.flow[0]}?next=${nextURL}`);
				// 		} else {
				// 			navigate(response.flow[0]);
				// 		}
				// 	} else {
				// 		if (nextURL) {
				// 			navigate(nextURL);
				// 		} else if (roleDetails) {
				// 			console.log(`${roleDetails.titleBeautify} login`);
				// 			navigate(roleDetails.defaultURL);
				// 		} else {
				// 			console.log("Unknown role login");
				// 			navigate("/"); 
				// 		}
				// 	}
			
				// 	setStatus(`Welcome to ${roleDetails ? roleDetails.context : 'Gasolina'}.com`);
				// }
				else {
					setStatus("No Token Received");
				}
			} else {
				addToastMessage({
					status: false,
					message: "Invalid username or password, please try again.",
				})
				setStatus("Invalid credentials, please try again.");
			}
		} catch {
			setStatus("An Error Occurred");
		} finally {
			setLoading(false);
		}
	};

	return (
		<section id='auth-page'>
			<PageTitle title='Login' />
			<section className='auth-header'>
				<div className='logo'>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='123.376'
						height='25'
						viewBox='0 0 123.376 25'>
						<g transform='translate(57.776 22)'>
							<path
								d='M-35.786-7.916h6.839a2.423,2.423,0,0,1,.026.287q.005.154.005.472a7.746,7.746,0,0,1-1.928,5.465A6.468,6.468,0,0,1-35.827.4,7.874,7.874,0,0,1-41.59-1.83,7.611,7.611,0,0,1-43.856-7.5a7.539,7.539,0,0,1,2.276-5.629,7.893,7.893,0,0,1,5.752-2.225,7.373,7.373,0,0,1,3.363.769,8.12,8.12,0,0,1,2.728,2.3l-2.164,1.6a5.264,5.264,0,0,0-1.7-1.451,4.55,4.55,0,0,0-2.061-.446A4.711,4.711,0,0,0-39.221-11.2a5.112,5.112,0,0,0-1.333,3.7A5.1,5.1,0,0,0-39.216-3.82a4.611,4.611,0,0,0,3.491,1.4,4.142,4.142,0,0,0,2.563-.743,2.323,2.323,0,0,0,.984-1.943v-.164h-3.609Zm16.57,2.871A3.168,3.168,0,0,0-19.9-7.188a2.307,2.307,0,0,0-1.841-.79,2.35,2.35,0,0,0-1.871.784,3.164,3.164,0,0,0-.682,2.148,3.1,3.1,0,0,0,.672,2.123,2.356,2.356,0,0,0,1.861.759,2.365,2.365,0,0,0,1.876-.759A3.11,3.11,0,0,0-19.216-5.045ZM-16.55,0h-2.83l.041-1.446a3.828,3.828,0,0,1-1.43,1.4A4.275,4.275,0,0,1-22.8.4,3.975,3.975,0,0,1-26.03-1.087a5.979,5.979,0,0,1-1.225-3.927,5.943,5.943,0,0,1,1.2-3.963A4.154,4.154,0,0,1-22.7-10.4a3.772,3.772,0,0,1,1.964.5,4.033,4.033,0,0,1,1.42,1.5v-1.661h2.769Zm1.764-1.764,2.246-1.159a1.4,1.4,0,0,0,.6.923,2.1,2.1,0,0,0,1.22.338,2.087,2.087,0,0,0,1.128-.261.815.815,0,0,0,.41-.723q0-.728-1.456-1.22-.451-.154-.718-.256a7.207,7.207,0,0,1-2.456-1.343,2.262,2.262,0,0,1-.682-1.671A2.9,2.9,0,0,1-13.33-9.526a4.8,4.8,0,0,1,3.056-.913A4.8,4.8,0,0,1-7.931-9.9,3.254,3.254,0,0,1-6.491-8.357L-8.634-7.291a1.545,1.545,0,0,0-.6-.856,1.875,1.875,0,0,0-1.077-.292,1.854,1.854,0,0,0-1.046.267.807.807,0,0,0-.4.7q0,.749,1.989,1.395.236.072.359.113A5.791,5.791,0,0,1-7.065-4.7a2.543,2.543,0,0,1,.7,1.841A2.834,2.834,0,0,1-7.526-.482,5.042,5.042,0,0,1-10.654.4a5.655,5.655,0,0,1-2.661-.579A2.926,2.926,0,0,1-14.786-1.764Zm18.17-3.25a2.686,2.686,0,0,0-.718-1.964A2.575,2.575,0,0,0,.738-7.711a2.55,2.55,0,0,0-1.917.728,2.7,2.7,0,0,0-.708,1.969,2.726,2.726,0,0,0,.708,1.969,2.531,2.531,0,0,0,1.917.738,2.569,2.569,0,0,0,1.923-.738A2.693,2.693,0,0,0,3.384-5.014Zm2.974.021A5.151,5.151,0,0,1,4.773-1.138,5.527,5.527,0,0,1,.759.4a5.572,5.572,0,0,1-4.04-1.538A5.143,5.143,0,0,1-4.871-4.994a5.147,5.147,0,0,1,1.6-3.855A5.56,5.56,0,0,1,.759-10.4,5.544,5.544,0,0,1,4.778-8.87,5.163,5.163,0,0,1,6.357-4.994ZM8.675,0V-15.894h2.912V0Zm5.732-14.191a1.638,1.638,0,0,1,.5-1.2,1.638,1.638,0,0,1,1.2-.5,1.675,1.675,0,0,1,1.215.5,1.624,1.624,0,0,1,.508,1.2,1.641,1.641,0,0,1-.508,1.21,1.666,1.666,0,0,1-1.215.5,1.621,1.621,0,0,1-1.2-.513A1.66,1.66,0,0,1,14.407-14.191ZM14.663,0V-10.059h2.912V0Zm5.875,0V-10.059H23.4V-8.48a5.344,5.344,0,0,1,1.7-1.451,4.341,4.341,0,0,1,2.015-.467A4.388,4.388,0,0,1,29.075-10a2.922,2.922,0,0,1,1.256,1.2,3.234,3.234,0,0,1,.323.948,10.072,10.072,0,0,1,.1,1.656V0H27.829V-4.973A4.643,4.643,0,0,0,27.4-7.424a1.7,1.7,0,0,0-1.477-.595,2.473,2.473,0,0,0-1.113.251,2.3,2.3,0,0,0-.846.713,2.325,2.325,0,0,0-.385.82,6.142,6.142,0,0,0-.118,1.4V0Zm20.4-5.045a3.168,3.168,0,0,0-.682-2.143,2.307,2.307,0,0,0-1.841-.79,2.35,2.35,0,0,0-1.871.784,3.164,3.164,0,0,0-.682,2.148,3.1,3.1,0,0,0,.672,2.123,2.356,2.356,0,0,0,1.861.759,2.365,2.365,0,0,0,1.876-.759A3.11,3.11,0,0,0,40.934-5.045ZM43.6,0H40.77l.041-1.446a3.828,3.828,0,0,1-1.43,1.4A4.275,4.275,0,0,1,37.345.4,3.975,3.975,0,0,1,34.12-1.087a5.979,5.979,0,0,1-1.225-3.927,5.943,5.943,0,0,1,1.2-3.963,4.154,4.154,0,0,1,3.348-1.42,3.772,3.772,0,0,1,1.964.5,4.033,4.033,0,0,1,1.42,1.5v-1.661H43.6Z'
								transform='translate(22 -2)'
								fill='#2980B9'
							/>
							<path
								d='M0,0H2V12H0Z'
								transform='translate(-33 -15)'
								fill='#e3e3e3'
							/>
							<path
								id='iconmonstr-drop-5'
								d='M6.706,8.687,15.489,4.7q.864,1.316,1.6,2.515L4.745,12.822A25.7,25.7,0,0,1,6.706,8.687ZM4.1,15.4A9.923,9.923,0,0,0,4,16.745a8.169,8.169,0,0,0,.217,1.847l15.255-6.932A28.781,28.781,0,0,0,18.15,9.017L4.1,15.4Zm2.731,7.532,13.834-6.288a11.148,11.148,0,0,0-.48-3.024L4.942,20.55A8.26,8.26,0,0,0,6.832,22.934Zm7.488-20C13.694,2.006,13.033,1.032,12.335,0,10.964,2.028,9.728,3.845,8.65,5.516Zm-5.4,21.333a8.356,8.356,0,0,0,11.4-5.18l-11.4,5.18Z'
								transform='translate(-61.776 -22)'
								fill='#2980B9'
							/>
						</g>
					</svg>
				</div>
				{/* <div className='options flex center-center'>
					<p>
						<NavLink to='/register'>Don't have an account?</NavLink>
					</p>
					<p>
						<NavLink to='/contact'>
							<span className='t-d-ul color-primary f-w-600'>
								Contact us
							</span>
						</NavLink>
					</p>
				</div> */}
			</section>
			<section className='auth-content'>
				<div className='inner'>
					<div className='col col-1-2 left'>
						<div className='text'>
							<h1 className='l-h-1 f-w-300 color-primary'>
								Welcome to
								<br />
								Gasolina!
							</h1>
							<br />
							<h5 className='f-w-300 color-primary'>
								{RS_TAGLINE}
							</h5>
						</div>
					</div>
					<div className='col col-1-2 right pos-rel'>
						<div className='box'>
							<Formik
								initialValues={initial}
								validationSchema={FormValidation}
								onSubmit={async (values, { resetForm }) => {
									handleLogin(
										values.username,
										values.password
									);
								}}>
								{({
									values,
									errors,
									touched,
									setFieldValue,
									resetForm,
								}) => (
									<Form>
										<h4 className='color-primary t-a-c'>
											Sign In
										</h4>
										<table>
											<thead></thead>
											<tbody>
												<tr>
													<td colSpan='2'>
														<p className='title f-w-700 color-primary'>
															Username:
														</p>
														<Field
															name='username'
															type='text'
															placeholder='Eg: john.doe@gmail.com *'
															className={
																" " +
																(errors.username &&
																	touched.username
																	? " error"
																	: "")
															}
														/>
														<ErrorMessage
															name='username'
															component='p'
															className='error-messages'
														/>
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<p className="title f-w-700 color-primary">Password:</p>
														<div className="password-field-wrapper">
															<Field
																name="password"
																type={showPassword ? 'text' : 'password'}
																placeholder="Password *"
																className={
																	" " + (errors.password && touched.password ? "error" : "")
																}
															/>
															<span
																onClick={togglePasswordVisibility}
																className="eye-icon"
																aria-label={showPassword ? 'Hide password' : 'Show password'}
															>
																{showPassword ? <FaRegEyeSlash /> : <FaEye />}
															</span>
														</div>
													</td>
												</tr>
												{/* <tr>
													<td colSpan='2'>
														<p className='title f-w-700 color-primary'>
															Password:
														</p>
														<Field
															name='password'
															type='password'
															placeholder='Password *'
															className={
																" " +
																(errors.password &&
																	touched.password
																	? " error"
																	: "")
															}
														/>
													</td>
												</tr> */}
												<tr>
													<td colSpan='2'>
														<br />
													</td>
												</tr>
												<tr>
													<td>
														<div className='flex'>
															<label
																htmlFor='checkId'
																style={{
																	display:
																		"flex",
																	alignItems:
																		"center",
																	gap: "10px",
																	cursor: "pointer",
																}}>
																<input
																	type='checkbox'
																	id='checkId'
																/>
																<p
																	className='color-primary'
																	style={{
																		fontSize:
																			"16px",
																	}}>
																	Remember me
																</p>
															</label>
														</div>
													</td>
													<td>
														<p
															className='t-a-r color-primary'
															style={{
																fontSize:
																	"14px",
															}}>
															{/* <NavLink to='/forgot-password'>
																<span className='transition hover-color-secondary'>
																	Forgot
																	Password?
																</span>
															</NavLink> */}
														</p>
													</td>
												</tr>
												<tr>
													<td colSpan='2'>
														{loading ? (
															<ButtonTextIcon
																type='button'
																title='Signing in...'
																disabled={
																	loading
																}
																icon={
																	<LoaderIcon />
																}
															/>
														) : (
															<ButtonTextOnly
																type='submit'
																title='Sign In'
															/>
														)}
													</td>
												</tr>
											</tbody>
										</table>
										{status && (
											<p className='status color-secondary f-w-300 l-h-1'>
												{status}
											</p>
										)}
									</Form>
								)}
							</Formik>
						</div>
					</div>
				</div>
			</section>
		</section>
	);
};

export default Login;
